import { jsx as _jsx } from "react/jsx-runtime";
import { RadiobuttonIcon } from "@radix-ui/react-icons";
import { CADIcon } from "../../../icons/currencies/CADIcon.js";
import { EURIcon } from "../../../icons/currencies/EURIcon.js";
import { GBPIcon } from "../../../icons/currencies/GBPIcon.js";
import { USDIcon } from "../../../icons/currencies/USDIcon.js";
export const defaultSelectedCurrency = {
    shorthand: "USD",
    name: "US Dollar",
    icon: USDIcon,
};
export const currencies = [
    defaultSelectedCurrency,
    {
        shorthand: "CAD",
        name: "Canadian Dollar",
        icon: CADIcon,
    },
    {
        shorthand: "GBP",
        name: "British Pound",
        icon: GBPIcon,
    },
    {
        shorthand: "EUR",
        name: "Euro",
        icon: EURIcon,
    },
];
export function getCurrencyMeta(shorthand) {
    return (currencies.find((currency) => currency.shorthand.toLowerCase() === shorthand.toLowerCase()) ?? {
        // This should never happen
        icon: UnknownCurrencyIcon,
        name: shorthand,
        shorthand: shorthand,
    });
}
const UnknownCurrencyIcon = (props) => {
    return _jsx(RadiobuttonIcon, { width: props.size, height: props.size });
};
//# sourceMappingURL=currencies.js.map